import React from "react";
import { Box } from "@material-ui/core";
import AppChipsComponent from "../../../components/form/app-chips";

const ChipsComponent = () => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "0 40px",
      }}
    >
      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <AppChipsComponent label="Small Chip" size="small" color="primary" />
        <AppChipsComponent label="Medium Chip" size="medium" color="primary" />
      </Box>
      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <AppChipsComponent
          label="Outlined Primary Chip"
          variant="outlined"
          size="medium"
          color="primary"
        />

        <AppChipsComponent
          label="Outlined Secondary Chip"
          variant="outlined"
          size="medium"
          color="secondary"
        />

        <AppChipsComponent
          label="Default Primary Chip"
          variant="default"
          size="medium"
          color="primary"
        />

        <AppChipsComponent
          label="Default Secondary Chip"
          variant="default"
          size="medium"
          color="secondary"
        />
      </Box>
    </Box>
  );
};

export default ChipsComponent;
